import type { ClearAppStoreResponseAction } from './clearAppStore.action';
import type { FetchAndroidAppNameResponseAction } from './fetchAndroidAppName.action';
import type { FetchIosAppNameResponseAction } from './fetchIosAppName.action';
import type { FetchQrCodeSettingsResponseAction } from './fetchQrCodeSettings.action';

export type AppStoreAction =
  | ClearAppStoreResponseAction
  | FetchAndroidAppNameResponseAction
  | FetchIosAppNameResponseAction
  | FetchQrCodeSettingsResponseAction;

export * from './clearAppStore.action';
export * from './fetchAndroidAppName.action';
export * from './fetchIosAppName.action';
export * from './fetchQrCodeSettings.action';
